<template>
  <div class="content">
    <ul class="five">
      <li class="five-item" v-for="(item, index) in DatasheetAndSpecification" :key="index">
        <div class="img-sty">
          <a class="img-hover"><img class="img-wh" :src="item.imagePath" /></a>
          <!-- <iframe style="border:none !important;" class="img-wh" :src="item.filePath"></iframe> -->
        </div>
        <div class="five-mesage">
          <p style="font-size:20px;font-weight:bold;margin-bottom:33px;color:#000;">
            <a class="a1">{{ item.title }}</a>
            <img v-if=" item.needLogin === 1 " src="../../assets/lock_icon.png">
          </p>
          <p class="p3" style="font-size:16px;margin-bottom:17px;color:#8d8d8d;line-height:30px;">{{ item.remark }}</p>
          <p @click="goDownload(item.filePath)">
            <img style="margin-right:18px;" src="../../assets/down_icon.png">
            <a>Download documents</a></p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
    export default {
        name: 'Third',
        props: {
          DatasheetAndSpecification: {
            type: Array,
            default: () => ([])
          },
        },
        mounted() {},
        methods: {
          // 下载
          goDownload(val){
            window.open(val);
          },
        }
    }
</script>

<style scoped>
.content {
  width: 100%;
  height: auto;
}
.five {
  padding: 30px 40px 0 27px;
}
.five-item {
  display:flex;
  justify-content: center;
  margin-bottom:40px;
}
.img-sty {
    width:225px;
    height:225px;
    overflow: hidden;
    max-width:225px;
    max-height:225px;
    border-radius: 3px;
    /* box-shadow: 2px 2px 2px #fcfcfc; */
    box-shadow: 0px 0px 5px rgb(119, 119, 119, 0.3);
    text-align:center;
  }
  .img-hover {
    object-fit: cover;
    transition: all 2s;
    overflow:hidden;
  }
  .img-hover :hover {
	/* 放大1.3倍 */
    transform: scale(1.2);
  }
  .img-wh {
    /* width:100%;
    height:auto;
    max-height:141px;
    max-width:100%; */
    width:100%;
    height:auto;
    margin-top:40px;
  }
  .five-mesage {
    flex:1;
    padding-left:30px;
  }
</style>